import * as angular from 'angular';

class NetworkPointBundleCreateProductTypesCtrl implements ng.IController {
    constructor() {}

    $onInit() {}

    public bundleRequest: BundleChangeRequestDto;
    public productPeriodType: ProductPeriodType[] = [
        'YEAR',
        'QUARTER',
        'MONTH',
        'DAY',
        'INTRADAY'
    ];
    public readonly: boolean;

    public addRemovePeriodType(action, periodType: ProductPeriodType) {
        if (!this.bundleRequest.availableProductTypes) {
            this.bundleRequest.availableProductTypes = [];
        }
        if (action) {
            if (
                this.bundleRequest.availableProductTypes.indexOf(periodType) ==
                -1
            ) {
                this.bundleRequest.availableProductTypes.push(periodType);
            }
        } else {
            this.bundleRequest.availableProductTypes.splice(
                this.bundleRequest.availableProductTypes.indexOf(periodType),
                1
            );
        }

        if (this.bundleRequest.availableProductTypes.length == 0) {
            delete this.bundleRequest.availableProductTypes;
        }
    }
}

angular.module('app').component('pkpNetworkPointBundleCreateProductTypes', {
    controller: NetworkPointBundleCreateProductTypesCtrl,
    template:
        require('app/network-point-bundle/network-point-bundle-create-product-types.component.html'),
    bindings: {
        form: '=',
        readonly: '<',
        bundleRequest: '='
    }
});
